/**
 * 项目级别通用常量或变量
 */

// 颜色主题，可选default(默认)、cnooc(中海油)
const sysTheme = 'default';

// 同源改造拼接的地址，地址为/bigdata
const partPath = '/bigdata';

export { sysTheme, partPath };
